import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
declare var $:any


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  constructor(private http : HttpClient) { }

  title:any 
  subtitle:any
  tt:any = []
  ngOnInit(): void {
    $(document).ready(function(){
      $('.sidenav').sidenav();
    });

    this.http.get('assets/data/title.json').subscribe(title => {
        this.tt = title

        for(let item of this.tt){
          this.title = item.title
        }
    })
  }

}
